import './loads-import-result-table.scss';
import { ClbTable } from '@celebration/react';
import { Column } from '@celebration/react/ClbTable/ClbTable.types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ILoadsImportResultTableProps from './interface/ILoadsImportResultTableProps';
import IParseResultTableData from '../../interfaces/IParseResultTableData';
import LoadsUtils from '../../../../utils';

function LoadImportResultTable({
    data,
}: Readonly<ILoadsImportResultTableProps>) {
    const { t } = useTranslation();
    const columns: Column<any>[] = [
        {
            dataIndex: 'line',
            title: t('Linha'),
        },
        {
            dataIndex: 'status',
            title: t('Status'),
        },
        {
            dataIndex: 'observation',
            title: t('Observacao'),
        },
    ];
    const [resultData, setResultData] = useState<IParseResultTableData[]>(
        [] as IParseResultTableData[],
    );
    const pageSize = useRef<number>(5);
    const page = useRef<number>(1);

    const itemsPerPageOptions = [5, 10, 15, 20];

    const totalItems = useMemo(() => {
        return data.length;
    }, [data]);

    const paginateData = useCallback(
        (page: number, quantity: number): void => {
            const startItem = (page - 1) * quantity;
            const endItemIndex = startItem + quantity;

            setResultData(data?.slice(startItem, endItemIndex));
        },
        [data],
    );

    useEffect(() => {
        paginateData(page.current, pageSize.current);
    }, [paginateData, page, pageSize]);

    const handleNextPage = useCallback(
        (newPage: number) => {
            page.current = newPage;
            paginateData(page.current, pageSize.current);
        },
        [paginateData, page, pageSize],
    );

    const handlePageSize = useCallback(
        (newPageSize: number) => {
            pageSize.current = newPageSize;
            paginateData(page.current, pageSize.current);
        },
        [pageSize, paginateData, page],
    );

    return (
        <ClbTable
            columns={columns}
            config={{
                pagination: {
                    page: page.current,
                    pageSize: pageSize.current,
                    totalItems,
                    customItemsPerPage: itemsPerPageOptions,
                    onChangePage: handleNextPage,
                    onChangePageSize: handlePageSize,
                    i18n: LoadsUtils.getI18nForTablePagination(t),
                },
                showFilterTags: false,
                tableEmpty: {
                    title: t('NaoHaDadosParaExibir'),
                },
            }}
            data={resultData}
        />
    );
}

export default LoadImportResultTable;
